<template>
  <div class="feedback-box">
    <div class="info-form">
      <van-field
        v-model="name"
        label="取货人姓名"
        placeholder="请输入取货人姓名"
        @blur="formCheck()"
        :error-message="errMsg.name"
      />
      <van-field
        v-model="phone"
        label="联系电话"
        placeholder="请输入联系电话"
        @blur="formCheck1()"
        :error-message="errMsg.phone"
      />
    </div>
    <div class="sing-box">
      <p class="sign">取货人签字</p>
      <div ref="signPane" class="sign-pane">
        <div v-if="!isSign" class="signTip">签名区</div>
        <vue-esign
          ref="esign"
          :width="343"
          :height="200"
          :isCrop="isCrop"
          :lineWidth="lineWidth"
          :lineColor="lineColor"
          :bgColor.sync="bgColor"
        />
      </div>
      <!-- <p v-if="!isSign" class="sign-tip">请签名</p> -->
      <!-- <div @click="handleReset" class="reset-sign">清空签名</div> -->
    </div>
    <div class="upload-box">
      <upload ref="upload" @fileuploadData="fileUploadData" :fileBizType="120" :sourceId="data.basicId"></upload>
      <!-- <p class="title">相关凭证</p> -->
      <!-- <van-uploader v-model="fileList" multiple @delete="delPreImg()">
        <img
          class="camera-icon"
          src="https://img0.baidu.com/it/u=561041293,259965800&fm=26&fmt=auto&gp=0.jpg"
          alt
        />
      </van-uploader> -->
    </div>
    <div class="btn" :class="formCheckPass ? 'btn-disable' : ''" @click="onSubmit">提交</div>
  </div>
</template>
<script>
    import upload from '../components/upload'
    import api from '../../../../service/modules/refund'

    export default {
        components: { upload },
        data () {
            return {
                Imglist: [],
                canvasWidth: 100,
                canvasHeight: 200,
                name: '',
                phone: '',
                errMsg: {
                    name: '',
                    phone: ''
                },
                fileList: [],
                lineWidth: 6,
                lineColor: '#000000',
                bgColor: '',
                resultImg: '',
                isCrop: false,
                isSign: false, // 是否签名
                basicId: '',
                data: {
                    basicId: 545556
                },
                timer: null,
            };
        },
        computed: {
            formCheckPass () {
                return !this.name || !this.phone || !this.isSign;
            }
        },
        created () {
            try {
                this.basicId = this.$route.query.basicId
            } catch (er) {
                // alert(er)
            }
        },
        mounted () {
            this.canvasWidth = this.$refs['signPane'].offsetWidth;
            const that = this;
            window.onresize = () => {
                return (() => {
                    // that.canvasHeight = that.$refs["signPane"].offsetHeight
                    // alert(document.getElementById('canvas').width)
                    // that.$refs['esign'] = that.$refs["signPane"].offsetWidth;
                    // that.canvasHeight = that.$refs["signPane"].offsetHeight;
                })();
            }
            this.timer = setInterval(() => {
              if (this.timer) {
                this.handleGenerate()
              }
            }, 0.5 * 1000);
        },
        beforeDestroy() {
          clearInterval(this.timer)
          this.timer = null
        },
        methods: {
            fileUploadData (val) {
                this.Imglist = val;
            },
            // 表单验证
            formCheck (type) {
                if (!this.name) {
                    this.errMsg.name = '请输入取货人姓名';
                } else {
                    this.errMsg.name = '';
                }
            },
            formCheck1 (type) {
                if (!this.phone) {
                    this.errMsg.phone = '请输入联系电话';
                } else {
                    this.errMsg.phone = '';
                }
            },
            async onSubmit () {
                try {
                    this.formCheck();
                    this.formCheck1();
                    await this.handleGenerate();
                    if (!this.name || !this.phone || !this.isSign) return;
                    const param = {
                        basicId: this.basicId,
                        userName: this.name,
                        userPhone: this.phone,
                        attachs: this.Imglist.join(','),
                        signAttachment: this.resultImg
                    }
                    console.log('pickParam', param)
                    api.pick(param).then(res => {
                        if (res.ret === 0) {
                            this.$Toast({
                                message: '提交成功'
                            });
                            setTimeout(() => {
                                this.$router.back();
                                // this.$router.replace({
                                //   path: "/refund/refundDetail",
                                //   query: {
                                //     flowId: this.data.flowId
                                //   }
                                // });
                            }, 1500);
                        }
                    })
                } catch (err) {
                    // alert(err)
                }
            },
            // 签名回调
            handleGenerate () {
                var _this = this
                this.$refs.esign
                    .generate()
                    .then(res => {
                        _this.timer = null
                        clearInterval(_this.timer)
                        _this.isSign = true;
                        _this.resultImg = res;
                        console.log('resultImg', this.resultImg)
                        // var blob = _this.dataURLtoBlob(res)
                        // console.log('blob', blob)
                        // const files = {
                        //     file: this.convertBase64UrlToBlob(res),
                        //     content: res
                        // }
                        // console.log('上传文件参数', files)

                        // this.$refs.upload.afterRead(files)
                        // var tofile = _this.blobToFile(blob, '取货人签名.jpg')
                        // 此处调接口
                    })
                    .catch(err => {
                        this.isSign = false;
                        console.log(err); // 画布没有签字时会执行这里 'Not Signned'
                    });
            },
            // base64转file
            convertBase64UrlToBlob (urlData) {
                var arr = urlData.split(','); var mime = arr[0].match(/:(.*?);/)[1];
                var bstr = atob(arr[1]); var n = bstr.length; var u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], { type: mime });
            },
            // 将base64转换为blob
            dataURLtoBlob (dataurl) {
                var arr = dataurl.split(',')
                var mime = arr[0].match(/:(.*?);/)[1]
                var bstr = atob(arr[1])
                var n = bstr.length
                var u8arr = new Uint8Array(n)
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new Blob([u8arr], { type: mime })
            },
            // 将blob转换为file
            blobToFile (theBlob, fileName) {
                theBlob.lastModifiedDate = new Date()
                theBlob.name = fileName
                return theBlob
            },
            // 清空签名
            handleReset () {
                this.$refs.esign.reset();
            },
            // 删除预览图片
            delPreImg () {
                // 没有图片是filelist是空，有内容时是一个对象
                console.log(this.fileList, 'filelist');
                // alert(this.fileList);
            }
        }
    };
</script>
<style lang="less" scoped>
.feedback-box {
  position: relative;
  min-height: 100vh;
  padding: 0 16px;
  .info-form {
    margin-bottom: 23px;
    .van-cell {
      padding: 15px 0;
      border-bottom: 1px solid #EEEEEE;
      /deep/.van-field__label {
        font-size: 14px;
        color: #171a1d;
        span::after {
          content: "*";
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #F94F4E;
          vertical-align: sub;
          margin-left: 2px;
        }
      }
      .van-field__value {
        .van-field__control {
          font-size: 14px;
          color: #cccccc;
          letter-spacing: 0;
          line-height: 14px;
        }
      }
    }
  }
  .sing-box {
    margin-bottom: 24px;
    .sign {
      font-size: 14px;
      color: #171a1d;
      margin-bottom: 12px;
      &::after {
        content: "*";
        color: red;
        margin-left: 2px;
      }
    }
    .sign-pane {
      background: #f8f9fb;
      width: 100%;
      height: 200px;
      margin-bottom: 12px;
      position: relative;
      .signTip {
        position: absolute;
        width: 100%;
        text-align: center;
        line-height: 200px;
        font-weight: 500;
        font-size: 64px;
        color: #eef0f2;
        pointer-events: none;
      }
    }
    .sign-tip {
      color: red;
    }
    // 重置电子签名的按钮
    .reset-sign {
    }
  }
  .upload-box {
    .title {
      font-size: 14px;
      color: #171a1d;
      line-height: 14px;
      margin-bottom: 12px;
    }
    /deep/.van-uploader {
      width: 80px;
      height: 80px;
      top: 0 !important;
      width: 100%;
      .van-uploader__input-wrapper {
        border: 1px dashed #a2a3a4;
        height: 75px;
        width: 75px;
        align-items: center;
        justify-content: space-around;
        .camera-icon {
          width: 22px;
          height: 22px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .van-icon-clear::before {
        content: "";
        width: 18px;
        height: 18px;
        background-image: url("../../../../assets/refund/ic_delete.png");
      }
    }
  }
  .btn {
    position: absolute;
    bottom: 0;
    background: #36b374;
    border-radius: 4px;
    color: white;
    padding: 0 16px;
    text-align: center;
    font-size: 16px;
    padding: 16px 0;
    color: white;
    width: 92%;
  }
}
.btn-disable {
  opacity: 50%;
}
</style>
